<template>
  <div class="htfbznrk between">
    <div class="htzn">
      <div class="title">合同指南</div>
      <div class="znlist between wrap">
        <div class="znitem text_center" style="border-bottom: 4px #FF9EDD solid;">
          <div class="flex"><img src="../../../assets/contmodeldet/icon01.png" /><div class="tit1">定义</div></div>
          
          <div class="dec1">
            合同是当事人或当事双方之间设立、变更、终止民事关系的协议。依法成立的合同，受法律保护
          </div>
        </div>
        <div class="znitem text_center" style="border-bottom: 4px #8EE69A solid;">
          <div class="flex"><img src="../../../assets/contmodeldet/icon02.png" /><div class="tit1">分类</div></div>
          
          <div class="dec1">
            广义合同指所有法律部门中确定权利、义务关系的协议。狭义合同指一切民事合同。还有最狭义合同仅指民事合同中的债权合同
          </div>
        </div>
        <div class="znitem text_center" style="border-bottom: 4px #A3B6FF solid;">
          <div class="flex"><img src="../../../assets/contmodeldet/icon03.png" /><div class="tit1">特征</div></div>
          
          <div class="dec1">
            合同是两个以上法律地位平等的当事人意思表示一致的协议。合同以产生、变更或终止债权债务关系为目的
          </div>
        </div>
        <div class="znitem text_center" style="border-bottom: 4px #FFBD3F solid;">
          <div class="flex"><img src="../../../assets/contmodeldet/icon04.png" /><div class="tit1">形式</div></div>
          
          <div class="dec1">
            口头形式是指当事人双方用对话方式表达相互之间达成的协议。书面形式是指当事人双方用书面方式表达相互之间通过协商一致而达成的协议
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="downrank">
      <div class="title">下载排行榜</div>
      <div class="dnrklist">
        <div
          v-for="(item, index) in 10"
          :key="index"
          @mouseover="rkactiv = index"
        >
          <div class="dnrkitem flex_start" v-if="index != rkactiv">
            <div class="sort" :class="{ sortqs: index < 3 }">{{ item }}</div>
            <div class="text ellipsis">房屋租赁合同范本大全</div>
          </div>
          <div class="dnrkitemact flex_start" v-if="index == rkactiv">
            <div class="cover">
              <img src="../../../assets/jpcol/htcover_sample.png" alt="" />
              <div class="sort" :class="{ sortqs: index < 3 }">{{ item }}</div>
            </div>
            <div class="text">
              <div>{{`房屋租赁合同范本大全` | toEllipsisFilter(27)}} </div>
              <div class="num flex_start">
                <div class="pric">¥9.9</div>
                <div class="xd">2100人下单</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
 
    <downrank class="downrank"  />
  </div>
</template>

<script>
import downrank from '../components/htrank'
export default {
  components:{
    downrank
  }
};
</script>

<style lang="scss" scoped>
.htfbznrk {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  .title {
    font-size: 24px;
    color: #333333;
  }
  .htzn {
    width: 856px;
    height: 608px;
    background: #ffffff;
    padding: 26px 30px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    .znlist {
      .znitem {
        margin-top: 22px;
        width: 380px;
        height: 240px;
        padding: 17px 34px;
		box-shadow: 0px 0px 20px 0px rgba(161, 166, 189, 0.15);
		border-radius: 5px;
		text-align: left;
        // background: url("../../../assets/jpcol/htfbzn_bg.png");
        .tit1 {
          font-size: 20px;
          color: #333333;
          line-height: 60px;
		  margin-left: 16px;
        }
        .dec1 {
          margin-top: 18px;
          font-size: 16px;
          color: #666666;
          line-height: 24px;
        }
      }
    }
  }
  .downrank {
    width: 314px;
    height: 608px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
   
  }
}
</style>